import { Card, Typography } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import CompletableTask from "../../../../components/CompletableTask";
import { addCompletedDialToSync } from "../../../../config/redux/slices/dialerSlice";
import {
  DEFAULT_DATETIME_DISPLAY_FORMAT,
  formatDateToString,
  isDateBefore,
} from "../../../../utils/date";
import {
  StyledDialDetails,
  StyledDialerPercentage,
  StyledDialerPercentageWrapper,
  StyledDialItem,
} from "./styles";

const DialItem = ({ dial: { data, ...dial } }) => {
  const dispatch = useDispatch();
  const onTaskComplete = (dial) => {
    toast.success(`Called ${dial.name}. Sync to upload`);
    dispatch(addCompletedDialToSync(dial.id));
  };
  const lastCompleted = formatDateToString(
    data.lastCompletedOn,
    DEFAULT_DATETIME_DISPLAY_FORMAT
  );
  const missedLastTime = isDateBefore(data.lastCompletedOn, dial.lastRunOn);
  const completionPercentage =
    100 - Math.round(data.failedAttempts / (data.totalAttempts || 1)) * 100;

  return (
    <Card elevation={4} sx={{ overflow: "visible" }}>
      <StyledDialItem>
        <CompletableTask
          fullWidth
          variant="bar"
          key={dial.key}
          data={data}
          title={dial.name}
          completed={dial.completed}
          onTarget={() => onTaskComplete(dial)}
          // renderModal={(data, setShowModal) => (
          //   <TaskDetailsModal data={data} setShowModal={setShowModal} />
          // )}
        />
        <StyledDialDetails>
          <Typography variant="body2" color="secondary">
            Call before: {data.countdown}
          </Typography>
          <Typography
            variant="body2"
            color={missedLastTime ? "error" : "secondary"}
          >
            Last call on: {lastCompleted}
          </Typography>
        </StyledDialDetails>
        <StyledDialerPercentageWrapper>
          <StyledDialerPercentage>
            <Typography
              variant="body2"
              color={data.streak < 0 ? "error" : "primary"}
            >
              {data.streak}
            </Typography>
          </StyledDialerPercentage>
          <StyledDialerPercentage>
            <Typography
              variant="body2"
              color={completionPercentage < 30 ? "error" : "primary"}
            >
              {completionPercentage}%
            </Typography>
          </StyledDialerPercentage>
        </StyledDialerPercentageWrapper>
      </StyledDialItem>
    </Card>
  );
};

export default DialItem;
